// styles.js atualizado
import { makeStyles } from "@mui/styles";

const styles = makeStyles((theme) => ({
  checked: {
    border: "2px solid " + theme.palette.primary.main,
    backgroundColor: theme.palette.primary.light + "10",
  },
  iconCheck: {
    color: theme.palette.primary.main + " !important",
    backgroundColor: theme.palette.primary.main + "20",
    borderRadius: "50%",
    padding: "4px",
  },
}));

export default styles;
